// has property type guard
type HasPropResult<T, K extends keyof T> = Extract<T, Partial<Record<K, T[K]>>>;

const hasProp = <
    T extends unknown | Date | string | number | Record<PropertyKey, unknown>,
    K extends PropertyKey,
>(
    item: T,
    propKey: K,
): item is T extends Record<PropertyKey, unknown>
    ? HasPropResult<T, K>
    : never => item != null && Object.hasOwn(item as object, propKey);

export { hasProp };
export type { HasPropResult };
